"use client";

import { InterestGroup } from "../../../app/storyblok/[localeString]/support-hub/types/contact.types";
import InterestsGroups from "../InterestsGroups/InterestsGroups";
import type { TypesenseSearchFieldProps } from "../TypesenseSearchField/TypesenseSearchField";
import { TypesenseSearchField } from "../TypesenseSearchField/TypesenseSearchField";
import { CosmosText, CosmosTitle } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./MobileHomepageMenu.module.css";

const cx = classNames.bind(styles);

export function MobileHomepageMenu({
  pageTitle,
  pageIntro,
  interestGroupsLabel,
  interestGroups,
  typesenseSearch,
}: {
  pageTitle: string;
  pageIntro?: React.ReactNode;
  interestGroupsLabel: string;
  interestGroups: InterestGroup[];
  typesenseSearch?: TypesenseSearchFieldProps;
}) {
  return (
    <div className={cx("drawer-container")}>
      <div data-resting-closed={false} id="drawer" className={cx("drawer")}>
        <div className={cx("scroll-container")} data-scroll-disabled={false}>
          <div className={cx("homepage-drawer-content")}>
            <div className={cx("header")} data-homepage="true">
              <CosmosTitle
                tag="h1"
                size="large"
                appearance="dark"
                weight="bold"
                className={cx("title")}
              >
                {pageTitle}
              </CosmosTitle>

              {/* TODO: Prose to allow for links */}
              {pageIntro && (
                <CosmosText
                  tag="div"
                  size="small"
                  appearance="dark"
                  className={cx("intro")}
                  kind="subtle"
                >
                  {pageIntro}
                </CosmosText>
              )}
            </div>

            {typesenseSearch && (
              <div className={cx("search")}>
                <TypesenseSearchField {...typesenseSearch} />
              </div>
            )}

            <InterestsGroups
              interestGroupsLabel={interestGroupsLabel}
              interests={interestGroups}
              dragProgress={0}
              hasMobileCarousel={false}
              isHomepage={true}
              appearance="dark"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
